var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebPopupNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Web_Popup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web_Popup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "WebPush-Copy",
    transform: "translate(23, 35)",
    fill: "#37474F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0023976,2.43745271 L6.84351607,2.43745271 L6.84351607,45.4326608 L76.0023976,45.4326608 L76.0023976,2.43745271 Z M75.2847957,44.7180748 L7.56111796,44.7180748 L7.56111796,3.15203867 L75.2847957,3.15203867 L75.2847957,44.7180748 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9710295,47.9551492 C82.8978341,47.7486339 82.7126928,47.6564523 82.5354452,47.6393022 L78.280066,47.6257251 C78.5434259,47.0897856 78.681923,46.5059689 78.681923,45.9071459 L78.681923,3.97381253 C78.681923,1.78289197 76.8922239,0 74.6920566,0 L8.26077979,0 C6.06133002,0 4.27163092,1.78217739 4.27163092,3.97381253 L4.27163092,45.9071459 C4.27163092,46.523119 4.41730411,47.1255149 4.69860404,47.6764607 L0.250189967,47.6764607 L0.145420092,47.7815048 C0.0672014868,47.8615385 -0.28585864,48.3002942 0.510679451,49.0906263 C2.24799361,50.8213535 5.9759354,50.9835645 6.13380781,50.9892812 L6.50696079,51 L6.50696079,50.9849937 C11.1828547,50.9864229 60.2216146,51 72.9812937,51 C75.9995272,51 76.0067032,50.9985708 76.00168,50.9985708 C79.6205463,50.9985708 81.034222,50.0217318 82.0654159,49.308575 C82.1709034,49.2349727 82.2720853,49.167087 82.3725495,49.1006305 L82.4278049,49.0556116 C82.9093157,48.5732661 83.072929,48.243842 82.9710295,47.9551492 Z M4.98923281,3.97381253 C4.98923281,2.17734342 6.45672866,0.71458596 8.26077979,0.71458596 L74.6920566,0.71458596 C76.4961077,0.71458596 77.9643212,2.17734342 77.9643212,3.97381253 L77.9643212,45.9071459 C77.9643212,46.5138293 77.7834855,47.0990752 77.4555414,47.6192938 L77.2890578,47.6307272 L5.49801254,47.6100042 C5.17150368,47.0905002 4.98923281,46.5088272 4.98923281,45.9057167 L4.98923281,3.97381253 Z M46.0848575,48.5368222 L46.0848575,48.9905843 L36.914623,48.9905843 L36.914623,48.5368222 L46.0848575,48.5368222 Z M81.9419884,48.5253888 C81.8487002,48.5868432 81.7532591,48.6540143 81.6549476,48.7211854 C80.7005371,49.3800336 79.3937841,50.2839849 75.9930688,50.2839849 C75.5589196,50.2897016 6.14600704,50.2704077 6.14600704,50.2704077 L6.08788129,50.2718369 C5.57336074,50.2411097 2.4352877,49.9981505 1.01658878,48.585414 C0.939805377,48.5096679 0.882397227,48.443926 0.840776317,48.3896175 L36.7359401,48.373182 L36.7359401,49.1699454 L46.2635403,49.1699454 L46.2635403,48.3688945 L82.1041664,48.3531736 C82.0611103,48.4003363 82.0087254,48.4575032 81.9419884,48.5253888 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BBCADF",
    fillRule: "nonzero",
    x: 51,
    y: 60,
    width: 30,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3E8F0",
    fillRule: "nonzero",
    x: 53,
    y: 65,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3E8F0",
    fillRule: "nonzero",
    x: 61,
    y: 65,
    width: 15,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#E3E8F0",
    fillRule: "nonzero",
    x: 61,
    y: 68,
    width: 15,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPopupNew);
export default __webpack_public_path__ + "static/media/Web_Popup_new.3829f4c167764058d6c53e7da4690f31.svg";
export { ForwardRef as ReactComponent };